import PropTypes from "prop-types";
import cn from "classnames";

import { ImgixNextImage as Image } from "@components/imgixNextImage";
import { useItineraryTheme } from "@pageComponents/itineraries/themes";

import { dangerHTML } from "@utils/danger";

export function Intro({ media = [], heading, html }) {
  const theme = useItineraryTheme();

  return (
    <section
      className={cn(
        "h-svh flex justify-center items-center",
        `${theme.background.secondary}`
      )}
    >
      <div className="container text-center">
        {media && media.length > 0 && (
          <Image
            className="mx-auto overflow-hidden rounded-full aspect-square"
            width={250}
            height={250}
            imgixParams={{ fit: "crop", w: 250, h: 250 }}
            src={media[0].url}
            alt={media[0].alt}
          />
        )}
        <h2
          className={cn(
            "mt-8 mb-2 font-rama text-5xl md:text-[96px] text-center font-extrabold uppercase overflow-ellipsis",
            `${theme.text.tertiary}`
          )}
        >
          {heading}
        </h2>
        <div
          className={cn(
            "mx-auto max-w-4xl font-mencken text-xl md:text-4xl",
            `${theme.text.tertiary}`
          )}
          {...dangerHTML(html)}
        />
      </div>
    </section>
  );
}

Intro.propTypes = {
  heading: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
  media: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string,
      credit: PropTypes.string,
      url: PropTypes.string.isRequired,
    })
  ),
};
